import { getCurrentHost } from "../../utils/getHost"

const styles = theme => ({
  textField: {
    border: "none",
    padding: 12,
    borderRadius: 2,
    marginRight: theme.spacing(4),
    outline: "none",
  },
  actionBarOuter: {
    minHeight: "80px",
    backgroundColor: getCurrentHost() === "crewmama" ? "#f3f3f3" : "#f3f3f3",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflow: window.innerWidth < 800 ? "scroll" : "initial",
  },
  actionBarInner: {
    paddingLeft: "32px",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      justifyContent: "center",
    },
  },
  actionBarSort: {
    justifyContent: "flex-end",
    alignItems: "center",
    flexGrow: "1",
    // paddingRight: "32px",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
      justifyContent: "center",
    },
  },
  sortButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionButtonWrapper: {
    display: window.innerWidth > 960 && "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: window.innerWidth < 960 && "center",
  },
  bookPositionButton: {
    marginLeft: theme.spacing(1),
  },
  sortWrapper: {
    display: "flex",
    alignItems: "center",
  },
  searchWrapper: {
    marginRight: theme.spacing(1),
    display: "flex",
  },
  filterSeperator: {
    width: 1,
    height: "80%",
    backgroundColor: theme.palette.divider,
    margin: `0 ${theme.spacing(1)}px`,
  },
})

export default styles
